export function isValidThemeID(themeID) {
    return themeID === 'light' || themeID === 'dark';
}
